import { EyeOff, Users02 } from "@untitled-ui/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import RadioGroup from "@/components/forms/RadioGroup";
import Legend from "@/components/helpers/Legend";

import GroupPrivacyRadio from "../creating-groups/GroupPrivacyRadio";
import type { GroupPrivacy } from "../creating-groups/types";
import GroupInviteLinkField from "./GroupInviteLinkField";
import GroupSubPageHeader from "./GroupSubPageHeader";

type GroupTypeEditPageProps = {
  type: GroupPrivacy;
  inviteUrl: string;
  onBack: () => void;
  onConfirm: (type: GroupPrivacy) => void;
  onCopyLink: () => void;
  isSaving?: boolean;
};

export default function GroupTypeEditPage({
  type,
  inviteUrl,
  onBack,
  onConfirm,
  onCopyLink,
  isSaving,
}: GroupTypeEditPageProps) {
  const { t } = useTranslation("messenger.user");
  const [draftType, setDraftType] = useState<GroupPrivacy>(type);

  return (
    <div className="flex h-full flex-col bg-white">
      <GroupSubPageHeader
        title={t("Group type")}
        onBack={onBack}
        onConfirm={() => onConfirm(draftType)}
        isConfirmLoading={isSaving}
      />

      <div className="flex flex-col gap-1 px-6 pt-4">
        <span className="text-md font-semibold text-gray-900">
          {t("Group type")}
        </span>
        <span className="text-sm text-gray-600">
          {t("Specify the group type")}
        </span>
      </div>

      <div className="flex flex-col gap-3 px-6 py-4">
        <RadioGroup
          value={draftType}
          onChange={setDraftType}
          direction="vertical"
          className="gap-3"
        >
          <GroupPrivacyRadio
            value="private"
            title={t("Private Group")}
            description={t("Private group join description")}
            icon={<EyeOff className="size-4" />}
          />
          <GroupPrivacyRadio
            value="public"
            title={t("Public Group")}
            description={t("Public group join description")}
            icon={<Users02 className="size-4" />}
          />
        </RadioGroup>
      </div>

      <Legend className="mx-6" />
      <GroupInviteLinkField inviteUrl={inviteUrl} onCopy={onCopyLink} />
    </div>
  );
}
